export default __webpack_public_path__ + "static/media/harvey1.645d51b3.jpg";